module.exports = __webpack_public_path__ + "img/sofa.c85b02d8.svg";